import type { IconType } from "react-icons";
import { FaInstagram, FaLinkedinIn, FaTiktok } from "react-icons/fa6";

/**
 * EZSpot's public social profiles, in the order they render. The footer renders
 * them and the Organization JSON-LD `sameAs` is built from them, so a repointed
 * or renamed account is a one-line change here.
 *
 * `label` is the accessible name of the icon-only link, so it names the
 * destination rather than the brand alone.
 */
export type SocialLink = {
  name: string;
  label: string;
  href: string;
  Icon: IconType;
};

export const SOCIAL_LINKS: SocialLink[] = [
  {
    name: "Instagram",
    label: "EZSpot on Instagram",
    href: "https://www.instagram.com/ezspot.ai/",
    Icon: FaInstagram,
  },
  {
    name: "LinkedIn",
    label: "EZSpot on LinkedIn",
    href: "https://www.linkedin.com/company/ezspot-ai/",
    Icon: FaLinkedinIn,
  },
  {
    name: "TikTok",
    label: "EZSpot on TikTok",
    href: "https://www.tiktok.com/@ezspot_ai",
    Icon: FaTiktok,
  },
];

/**
 * Clicks are measured through PostHog autocapture, which preserves `data-attr`,
 * so one `$autocapture` insight broken down by it answers which profile the
 * footer actually sends people to — no custom events to maintain. Mirrors
 * `badgeAttr()` in `~/lib/constants/app-store`.
 */
export function socialAttr(name: string, surface: "footer"): string {
  return `social-${name.toLowerCase()}-${surface}`;
}
